import { Check } from 'lucide-react';
import { formatUsd } from '../../lib/funnel-prices';

export interface Bump {
  id: 'quick_start_kit';
  name: string;
  price_cents: number;
  description: string;
  includes: string[];
}

export interface BumpToggleProps {
  bump: Bump;
  selected: boolean;
  onChange: (selected: boolean) => void;
  /**
   * Issue #1321: true while the PaymentIntent request is in flight. That request
   * already carries the bump selection, so a tick after it leaves is silently
   * dropped — better to refuse the input than to accept and ignore it.
   */
  disabled?: boolean;
}

export function BumpToggle({ bump, selected, onChange, disabled = false }: BumpToggleProps) {
  return (
    <label
      className={`block rounded-lg border p-5 transition ${
        disabled ? 'cursor-default opacity-60' : 'cursor-pointer'
      } ${
        selected
          ? 'border-brand-coral/70 bg-brand-coral/10 shadow-[0_20px_50px_rgba(254,89,99,0.14)]'
          : 'border-white/10 bg-white/[0.035] hover:border-white/20 hover:bg-white/[0.055]'
      }`}
    >
      <div className="flex items-start gap-4">
        <input
          type="checkbox"
          checked={selected}
          disabled={disabled}
          onChange={(event) => onChange(event.target.checked)}
          className="mt-1 h-5 w-5 accent-brand-coral"
        />
        <div className="min-w-0 flex-1">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
            <div>
              <p className="text-base font-bold text-white">{bump.name}</p>
              <p className="mt-1 text-sm leading-6 text-slate-400">{bump.description}</p>
            </div>
            <p className="shrink-0 text-lg font-bold text-brand-coral">{formatUsd(bump.price_cents)}</p>
          </div>
          <ul className="mt-4 grid gap-2 text-sm text-slate-300">
            {bump.includes.map((item) => (
              <li key={item} className="flex gap-2">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand-teal" />
                {item}
              </li>
            ))}
          </ul>
          <p className="mt-4 text-xs font-semibold text-slate-500">
            Normally $97 - only available with your Blueprint purchase.
          </p>
        </div>
      </div>
    </label>
  );
}
